export enum GameType {
  NONE = "None",
  BEST_OF_X = 'Best of 10 Throws',
};